import { useEffect } from "react";
import SlidellHeroSection from "./components/HeroSection";
import SlidellStickyNav from "./components/StickyNav";
import SlidellProcessingTimeSection from "./components/ProcessingTimeSection";
import SlidellServicesSection from "./components/ServicesSection";
import SlidellLocalAreaSection from "./components/LocalAreaSection";
import SlidellTestimonialsSection from "./components/TestimonialsSection";
import SlidellAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import SlidellComparisonSection from "./components/ComparisonSection";
import SlidellMistakesSection from "./components/MistakesSection";
import SlidellHowItWorksSection from "./components/HowItWorksSection";
import SlidellFAQSection, { faqs } from "./components/FAQSection";
import SlidellHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import SlidellFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import SlidellTravelTimingSection from "./components/TravelTimingSection";
import SlidellDestinationsSection from "./components/DestinationsSection";

export default function SlidellPage() {
  useEffect(() => {
    document.title = "Emergency Passport Slidell, LA — Expedited Same-Day Service | Fast Passport Center";

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute("name", name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setLink = (rel: string, href: string) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); document.head.appendChild(el); }
      el.setAttribute("href", href);
    };

    const pageUrl = "https://fastpassportcenter.com/slidell/";
    setLink("canonical", pageUrl);
    setMeta("description", "Emergency and expedited passport services in Slidell, LA — as fast as 24 hours. Serving Northshore families, commuters, and Gulf Coast travelers in St. Tammany Parish. A+ BBB rated, registered State Dept. courier.");
    setMeta("geo.placename", "Slidell, Louisiana");
    setMeta("geo.region", "US-LA");
    setMeta("geo.position", "30.2749;-89.7812");
    setMeta("ICBM", "30.2749, -89.7812");

    const graph = [
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Home", item: "https://fastpassportcenter.com/" },
          { "@type": "ListItem", position: 2, name: "Louisiana", item: "https://fastpassportcenter.com/louisiana/" },
          { "@type": "ListItem", position: 3, name: "Slidell Passport Services", item: pageUrl },
        ],
      },
      {
        "@type": "LocalBusiness",
        name: "Fast Passport Center",
        description: "Emergency and expedited passport services for Slidell and St. Tammany Parish. As fast as 24 hours.",
        url: pageUrl,
        telephone: "+1-877-253-0084",
        areaServed: { "@type": "City", name: "Slidell", containedInPlace: { "@type": "State", name: "Louisiana" } },
        priceRange: "$$$",
        openingHours: ["Mo-Fr 09:00-18:00"],
        aggregateRating: { "@type": "AggregateRating", ratingValue: "4.9", reviewCount: "1200" },
      },
      {
        "@type": "FAQPage",
        mainEntity: faqs.map((faq) => ({ "@type": "Question", name: faq.q, acceptedAnswer: { "@type": "Answer", text: faq.a } })),
      },
    ];

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "structured-data-slidell";
    document.getElementById("structured-data-slidell")?.remove();
    script.textContent = JSON.stringify({ "@context": "https://schema.org", "@graph": graph });
    document.head.appendChild(script);

    return () => {
      document.getElementById("structured-data-slidell")?.remove();
      const canonical = document.querySelector('link[rel="canonical"]');
      if (canonical) canonical.remove();
    };
  }, []);

  return (
    <div className="font-sans">
      <SlidellHeroSection />
      <SlidellStickyNav />
      <SlidellProcessingTimeSection />
      <SlidellServicesSection />
      <SlidellLocalAreaSection />
      <SlidellTravelTimingSection />
      <SlidellDestinationsSection />
      <SlidellTestimonialsSection />
      <SlidellAcceptanceFacilitiesSection />
      <SlidellComparisonSection />
      <SlidellMistakesSection />
      <SlidellHowItWorksSection />
      <SlidellFAQSection />
      <SlidellHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/slidell" state="LA" />
      <SlidellFinalCTA />
    </div>
  );
}